import MoveTo from './MoveTo'

export default class PlayerMoveTo extends MoveTo {
    constructor(player, time, position, imAnOwner, withOpacity) {
        super(player, time, position);
        this.ImAnOwner = imAnOwner;
        this.Changed = false;
        this.WithOpacity = withOpacity;
    }

    AdditionalRender(progress) {
        if(progress > 0.85 && !this.Changed) {
            this.Entity.zIndex = this.ImAnOwner ? 2 : 1;
            this.Changed = true;
        }

        if(this.WithOpacity) {
            if(progress > 0 && progress < 0.4)
                this.Entity.setOpacity(0.4 - progress)
            else if(progress > 0.6 && progress <= 1.0)
                this.Entity.setOpacity((progress-0.6)/0.4)
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/PlayerMoveTo.js
 **/